import Vue from "vue";

import Toasted from "vue-toasted";

Vue.use(Toasted, {
  theme: "bubble",
  position: "top-center",
  duration: 1500
});

import VueResource from "vue-resource";

Vue.use(VueResource);
Vue.http.options.root = "/api";

import * as errors from "@/errors";

Vue.http.interceptors.push((request, next) => {
  //Normalize data
  if (request.body) {
    Object.keys(request.body).map(key => {
      if (request.body[key] === "") {
        request.body[key] = null;
      }
    });
  }

  next(response => {
    const status = response.status;

    if (status !== 200) {
      const message = response.body.message;

      if (status === 401) {
        switch (response.data.api_code) {
          case "auth.twoFactor":
          case "authService.twoFactor":
            throw new errors.TwoFactorRequired();
          case "userService.userLocked":
          case "api.userLocked":
            throw new errors.Locked(response.data.message);
          case "authService.notActive":
          case "userService.notActive":
            throw new errors.NotActive();
          default:
            throw new errors.UnauthorizedError(message);
        }
      }

      if (status === 504 || status === 502) {
        Vue.toasted.error(
          "Service temporaraly unavailable. Please try again later.",
          {
            duration: 4000
          }
        );
        throw new errors.ServiceUnavailable();
      }

      if (status >= 500) {
        Vue.toasted.error("An error occured on the server.", {
          duration: 4000
        });
        throw new errors.ServerError(message);
      }

      if (status === 400) {
        switch (response.data.api_code) {
          case "auth.noEmail":
            throw new errors.EmailRequired();
          case "userService.userLocked":
          case "api.userLocked":
            throw new errors.Locked(response.data.message);
          default:
            Vue.toasted.error(message, {
              duration: 4000
            });
            throw new errors.ValidationError(message);
        }
      }

      Vue.toasted.error(message, {
        duration: 4000
      });

      throw new Error(message);
    }

    return response;
  });
});

export default Vue;
